export default "__VITE_ASSET__C4wZe82Z__"